export const abbreviations = {
  en: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    milliseconds: 'ms'
  },
  de: {
    days: 'd',
    hours: 'h',
    minutes: 'min',
    seconds: 's',
    milliseconds: 'ms'
  },
  fr: {
    days: 'j',
    hours: 'h',
    minutes: 'n',
    seconds: 's',
    milliseconds: 'ms'
  },
  es: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    milliseconds: 'ms'
  },
  pt: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    milliseconds: 'ms'
  },
  ru: {
    days: 'д',
    hours: 'ч',
    minutes: 'м',
    seconds: 'с',
    milliseconds: 'мс'
  },
  tr: {
    days: 'g',
    hours: 's',
    minutes: 'd',
    seconds: 'n',
    milliseconds: 'ms'
  },
  cn: {
    days: '天',
    hours: '时',
    minutes: '分',
    seconds: '秒',
    milliseconds: '毫秒'
  },
  jp: {
    days: '日',
    hours: '時',
    minutes: '分',
    seconds: '秒',
    milliseconds: 'ミリ秒'
  },
  cz: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    milliseconds: 'ms'
  },
  ko: {
    days: '일',
    hours: '시간',
    minutes: '분',
    seconds: '초',
    milliseconds: '밀리초'
  }
};
